import { UserVarKey, UserVarsMap } from "@swivl-mono/types";
import { Button, ButtonColor } from "@swivl-mono/ui";
import { memo } from "react";

interface DataCardFooterInterface {
  handleSetStore: () => void;
  handleViewFullDetails: () => void;
  locationId: number | undefined;
  userVars: UserVarsMap | undefined;
}

const BaseDataCardFooter = ({ handleSetStore, handleViewFullDetails, locationId, userVars }: DataCardFooterInterface) => {
  return (
    <div className="flex justify-between">
      <Button onClick={handleViewFullDetails} color={ButtonColor.WHITE}>
        View Full Details
      </Button>
      <Button disabled={Boolean(locationId && userVars?.[UserVarKey.Location] === String(locationId))} onClick={handleSetStore}>
        Set Store
      </Button>
    </div>
  );
};

export const DataCardFooter = memo(BaseDataCardFooter);

DataCardFooter.displayName = "DataCardFooter";
